class Programma
{
   constructor(section_id)
   {
      this.section_id = section_id;
      this.eventi = document.getElementById(`events-${section_id}`);
      this.init();
   }

   getTemplate = (data) =>
   {
      const html = `
      <div class="ui-wrapper mt-4">
         ${data?.nome_e_cognome ? `<h3 class="heading text-magenta text-uppercase">${data?.nome_e_cognome}</h3>` : ``}
         ${data?.dettagli ? `<div class="details text-lg-right mt-3">${data?.dettagli}</div>` : ``}
         <div class="info mt-3">
            ${data?.stile_genere ? `<div class="genre">Genere: ${data?.stile_genere}</div>` : ``}
            ${data?.nazione ? `<div class="country">Country: <em>${data?.nazione}</em></div>` : ``}
         </div>
         ${data?.immagine ? `
         <div class="image mt-5">
            <figure class="mb-0">
               ${data?.demo_video ? `
               <a href="${data?.demo_video}" class="video-link d-block position-relative" data-fancybox>
               <img
                  src="${data?.immagine}"
                  class="img-fluid w-100"
                  loading="lazy"
               >
                  <div class="overlay"></div>
               </a>
               `: `
               <img
                  src="${data?.immagine}"
                  class="img-fluid w-100"
                  loading="lazy"
               >
               `}
               
            </figure>
         </div>
         `: ``}

         ${data?.demo_audio ? `
            <div class="audio d-flex justify-content-center mt-3">
               <audio controls>
                  <source src="${data?.demo_audio}" type="audio/mpeg">
                  Your browser does not support the audio element.
               </audio>
            </div>
         `: ``}

         ${data?.descrizione_evento ? `
         <div class="rte mt-5">
            ${data?.descrizione_evento}
         </div>
         `: ``}

         ${data?.social_links?.length > 0 ? `
            <ul class="d-flex social-links mt-4">
               ${data?.sito_web ? `
                  <li class="pr-2"><a target="_blank" href="${data?.sito_web}">${window.icons.globe} <small>website</small></a></li>
               `: ``}
               ${data?.social_links.map(url =>
               {
                  if (url.includes('facebook'))
                  {
                     return `<li><a target="_blank" href="${url}">${window.icons.facebook}</a></li>`;
                  } else if (url.includes('instagram'))
                  {
                     return `<li><a target="_blank" href="${url}">${window.icons.instagram}</a></li>`;
                  } else if (url.includes('twitter'))
                  {
                     return `<li><a target="_blank" href="${url}">${window.icons.twitter}</a></li>`;
                  } else if (url.includes('pinterest'))
                  {
                     return `<li><a target="_blank" href="${url}">${window.icons.pinterest}</a></li>`;
                  } else if (url.includes('tiktok'))
                  {
                     return `<li><a target="_blank" href="${url}">${window.icons.tiktok}</a></li>`;
                  } else if (url.includes('youtube'))
                  {
                     return `<li><a target="_blank" href="${url}">${window.icons.youtube}</a></li>`;
                  } else if (url.includes('spotify'))
                  {
                     return `<li><a target="_blank" href="${url}">${window.icons.spotify}</a></li>`;
                  } else
                  {
                     return '';
                  }
               }).join('')}
            </ul>
         ` : ``}
         </div>
         `;
      return html;
   }

   renderScheda = (data) =>
   {
      const html = this.getTemplate(data);
      const container = document.getElementById(`artist-details-${this.section_id}`);
      console.log('container', container);
      console.log('container.offsetTop', container.offsetTop + container.clientTop);
      container.innerHTML = html;
   }

   setListeners = () =>
   {
      if (this.eventi)
      {
         const links = this.eventi.querySelectorAll('a[data-artist]');
         const tabsNav = this.eventi.querySelectorAll('input.event-day');
         const artistiEvento = this.eventi.querySelectorAll('.tab-artisti-evento');
         const container = document.getElementById(`artist-details-${this.section_id}`);


         if (links.length > 0)
         {
            links.forEach(link =>
            {
               link.addEventListener('click', e =>
               {
                  e.preventDefault();
                  window.location.hash = ``;
                  const clickedLink = e.target;
                  clickedLink.classList.add("active");

                  links.forEach(function (link)
                  {
                     if (link !== clickedLink)
                     {
                        link.classList.remove("active");
                     }
                  });

                  const data = JSON.parse(clickedLink.dataset.artist);
                  this.renderScheda(data);

                  window.location.hash = `artist-details-${this.section_id}`;
               });
            });
         }

         if (tabsNav.length > 0)
         {
            [...tabsNav].forEach(btn =>
            {
               btn.addEventListener('change', function ()
               {

                  const selectedId = this.value;
                  artistiEvento.forEach(item =>
                  {
                     const item_id = item.dataset.id;
                     if (item_id === selectedId)
                     {
                        item.hidden = false;
                     } else
                     {
                        item.hidden = true;
                     }
                  });

                  if (links.length > 0)
                  {
                     links.forEach(function (link)
                     {
                        link.classList.remove("active");
                     });
                  }

                  container.innerHTML = '';
               });
            });
         }
      }
   }

   init = () =>
   {
      this.setListeners();
   }
}